export default __webpack_public_path__ + "static/media/bakrenecijevi.712a9f5f.jpg";